<template>
  <div class="flex-box pl5 pr5 mb10 al-c" :style="compWidth()">
    <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
    <div class="flex-1">
      <el-time-picker v-model="value" value-format="HH:mm:ss" :placeholder="typeData.placeholder ? typeData.placeholder : '选择' + typeData.label"></el-time-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeComp",
  props: ["type-data", "width", "colspan"],
  components: {},
  data() {
    return {
      value: this.typeData.value ? this.typeData.value : null
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    compWidth() {
      if (this.colspan) {
        if (typeof this.colspan == "number") {
          return { width: this.colspan + "px" };
        } else {
          return { width: this.colspan };
        }
      } else {
        return { width: "33%" };
      }
    }
  }
};
</script>

<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
</style>
